import iso6391 from 'iso-639-1';

const getLangDisplayList=(codelist=[])=>{
    
    const langList=codelist.map(code=>({code,name:iso6391.getName(code)}));

    return langList.filter(lang=>lang.name);
}

const getQualityDisplayList=(qualityList=[],qualityLimit)=>{

    return qualityList.filter(({height},index,self)=>{
                            let unique=self.findIndex(quality=>quality.height===height) === index;
                            
                            qualityLimit=Number(qualityLimit);
                            let qualityCheck=isNaN(qualityLimit)?true:(height<=qualityLimit);

                            return (height && unique && qualityCheck);

                            }).sort((a,b)=>(a.height>b.height?1:-1))      
}

export {getLangDisplayList,getQualityDisplayList};